import React from "react";
import { Link } from "react-router-dom";
import { Leaf, Heart, Award, Users } from "lucide-react";
import { Button } from "../components/ui/button";
import { Seo } from "../components/Seo";

const IMG = "https://images.unsplash.com/photo-1626253934161-08cfea22e968?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000";
const IMG2 = "https://images.pexels.com/photos/14275717/pexels-photo-14275717.jpeg?auto=compress&cs=tinysrgb&w=1000";

export default function About() {
  return (
    <div className="fade-in">
      <Seo title="Our Story" description="Aadvan Dry Fruits — a premium dry fruit store rooted in Sitapur, crafting freshness and luxury gifting for every home." />
      <section className="bg-forest text-cream py-20">
        <div className="max-w-4xl mx-auto px-4 lg:px-8 text-center">
          <span className="text-xs uppercase tracking-[0.3em] text-gold">Our Story</span>
          <h1 className="font-serif text-5xl lg:text-6xl mt-3 leading-tight">Rooted in Sitapur.<br /><span className="italic text-gold">Crafted for you.</span></h1>
          <p className="text-cream/70 mt-5 max-w-2xl mx-auto leading-relaxed">
            Aadvan Dry Fruits began as a humble 250 sq.ft premium store in Sitapur, Uttar Pradesh, with a single
            promise — to bring the purest, freshest and most luxurious dry fruits to every home.
          </p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-4 lg:px-8 py-16 grid lg:grid-cols-2 gap-12 items-center">
        <img src={IMG} alt="Aadvan store" className="rounded-[2rem] w-full h-[420px] object-cover" />
        <div>
          <span className="text-xs uppercase tracking-[0.3em] text-gold">Why Aadvan</span>
          <h2 className="font-serif text-4xl text-forest mt-2">A legacy of freshness & trust</h2>
          <p className="mt-4 text-muted-foreground leading-relaxed">
            Every nut, seed and dry fruit we sell is handpicked at peak season, quality-checked, and packed fresh.
            We work directly with trusted growers across India and the world to ensure that what reaches you is nothing
            short of exceptional.
          </p>
          <p className="mt-4 text-muted-foreground leading-relaxed">
            From festive gifting to everyday nourishment, Aadvan blends old-world warmth with modern convenience —
            now delivering across Sitapur.
          </p>
          <Link to="/products"><Button className="mt-6 bg-gold text-forest hover:bg-gold-soft rounded-full h-12 px-8 text-sm uppercase tracking-[0.15em]" data-testid="about-shop-button">Explore Products</Button></Link>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-4 lg:px-8 py-8 grid grid-cols-2 md:grid-cols-4 gap-8">
        {[
          { icon: Leaf, t: "100% Natural", d: "No preservatives, ever" },
          { icon: Award, t: "Premium Grade", d: "Only the finest selection" },
          { icon: Heart, t: "Loved Locally", d: "Sitapur's trusted name" },
          { icon: Users, t: "Family First", d: "Gifting made effortless" },
        ].map((v) => (
          <div key={v.t} className="text-center p-6 rounded-2xl bg-sand">
            <div className="w-12 h-12 rounded-full bg-forest text-cream flex items-center justify-center mx-auto mb-3"><v.icon size={20} /></div>
            <div className="font-serif text-xl text-forest">{v.t}</div>
            <div className="text-xs text-muted-foreground mt-1">{v.d}</div>
          </div>
        ))}
      </section>

      <section className="max-w-7xl mx-auto px-4 lg:px-8 py-16 grid lg:grid-cols-2 gap-12 items-center">
        <div className="order-2 lg:order-1">
          <span className="text-xs uppercase tracking-[0.3em] text-gold">The Promise</span>
          <h2 className="font-serif text-4xl text-forest mt-2">Purity in every packet</h2>
          <p className="mt-4 text-muted-foreground leading-relaxed">
            We believe luxury is in the details — the crunch of a freshly roasted almond, the caramel softness of a
            Medjool date, the elegance of a beautifully wrapped gift box. That's the Aadvan experience.
          </p>
        </div>
        <img src={IMG2} alt="Luxury gifting" className="rounded-[2rem] w-full h-[400px] object-cover order-1 lg:order-2" />
      </section>
    </div>
  );
}
